
import dayjs from "dayjs"
import { markNotificationAsRead } from "@/api/notification"
import { renderedLinkText } from "@/utils/utils"

export default {
  name: "NotificationItem",
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    isNotificationCenter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  methods: {
    renderedLinkText,
    isRecentMessage(sentTimeUnix) {
      const now = dayjs()
      const msgTime = dayjs(sentTimeUnix)
      const sevenDaysAgo = now.subtract(7, "day")
      return msgTime.isAfter(sevenDaysAgo)
    },
    learnMore(item) {
      this.markAsRead(item)
      this.$emit("learnMore", item)
    },
    async markAsRead(item) {
      if (item.readStatus === 1) {
        return
      }

      const params = {
        msgId: item.msgId
      }
      const { data } = await markNotificationAsRead({ param: JSON.stringify(params) })
      if (data) {
        item.readStatus = 1
        this.$emit("handleMarkAsRead", item)
        this.$bus.$emit("getUnreadFlag")
      }
    }
  }
}
